export const checkAppVersionCompatibility = (
  appVersion: string,
  backendVersion: string,
) => {
  const [appMajor, appMinor, appPatch] = appVersion.split('.').map(Number);
  const [backendMajor, backendMinor, backendPatch] = backendVersion
    .split('.')
    .map(Number);

  return (
    appMajor === backendMajor &&
    appMinor === backendMinor &&
    appPatch <= backendPatch
  );
};
